export const json={
	"logoPosition": "right",
	"pages": [
	 {
	  "name": "page1",
	  "elements": [
	{
	    "type": "radiogroup",
	    "name": "Gender",
	    "title": "Gender",
	    "isRequired": true,
	    "choices": [
	     {
	      "value": 0,
	      "text": "Female"
	     },
	     {
	      "value": 1,
	      "text": "Male"
	     }
	    ]
	   },
	{
	    "type": "text",
	    "inputType":"number",
	    "name": "Age",
	    "title": "Age",
	    "isRequired": true
	   },
	{
	    "type": "text",
	    "name": "SurveyNo",
	    "inputType":"number",
	    "title": "Survey No",
	    "isRequired": false
	   }
	
	  ]
	 }
	 
	]
       }